/// <reference types="react-dom" />

import React = require("react");
import ReactDOM = require("react-dom");
import * as Component_Base from "VSS/Flux/Component";
import { Control } from "VSS/Controls";
import { IOAuthConfigurationState, OAuthConfigurationStore } from "DistributedTask/Scripts/OAuthConfiguration/Stores/OAuthConfigurationStore";
import { Hub } from "VSSUI/Hub";
import { IHubViewState, HubViewState } from "VSSUI/Utilities/HubViewState";
import { IHubBreadcrumbItem, HubHeader } from "VSSUI/HubHeader";
import { showConfirmNavigationDialog } from "VSS/Controls/Dialogs";
import { StoreManager } from "DistributedTaskControls/Common/Stores/StoreManager";
import Utils_Url = require("VSS/Utils/Url");
import * as Resources from "DistributedTask/Scripts/Resources/TFS.Resources.DistributedTask";
import { NavigationConstants } from "DistributedTask/Scripts/OAuthConfiguration/Common/OAuthConfigurationConstants";
import * as Navigation_Services from "VSS/Navigation/Services";
import * as Utils_String from "VSS/Utils/String";
import { TextField } from "VSSUI/TextField";
import { FormItem } from "VSSUI/FormItem";
import { OAuthConfigurationActionCreator } from "DistributedTask/Scripts/OAuthConfiguration/Actions/OAuthConfigurationActionCreator";
import { ActionCreatorManager } from "DistributedTaskControls/Common/Actions/ActionCreatorManager";
import { Dropdown, IDropdownOption } from "OfficeFabric/Dropdown";
import { ServiceEndpointType } from "DistributedTasksCommon/ServiceEndpoints/ServiceEndpoint.Common";
import { PrimaryButton} from "OfficeFabric/Button";
import * as Contracts from "TFS/ServiceEndpoint/Contracts";
import { ActionsHubManager } from "DistributedTaskControls/Common/Actions/ActionsHubManager";
import { OAuthConfigurationActions } from "DistributedTask/Scripts/OAuthConfiguration/Actions/OAuthConfigurationActions";
import { ErrorMessageBar } from "DistributedTask/Scripts/Components/ErrorMessageBar";
import { Dialogs } from "DistributedTask/Scripts/Components/Dialogs";
import { LibraryItemType } from "DistributedTask/Scripts/DT.Types";
import { getRunningDocumentsTable, RunningDocumentsTableEntry, RunningDocument } from "VSS/Events/Document";
import * as Events_Action  from "VSS/Events/Action";
import { UrlHelper } from "DistributedTask/Scripts/DT.Utils";
import { ExtensionArea } from "DistributedTask/Scripts/Constants";
import { OAuthConfigurationHubEvents } from "DistributedTask/Scripts/OAuthConfiguration/Common/OAuthConfigurationConstants";
import "VSS/LoaderPlugins/Css!RM:DistributedTask/Scripts/OAuthConfiguration/Components/OAuthConfigurationView";
import { IHeaderCommandBarItem, HeaderCommandBar } from "VSSUI/HeaderCommandBar";
import { Page } from "VSSUI/Page";
import { IMenuItem } from "VSSUI/Menu";
import { Icon } from "VSSUI/Icon";
import { Tooltip } from "VSSUI/TooltipEx";

export class OAuthConfigurationView extends Component_Base.Component<Component_Base.Props, IOAuthConfigurationState> implements RunningDocument {
    constructor(props?: Component_Base.Props) {
        super(props);
        this._hubViewState = new HubViewState();
        this._store = StoreManager.GetStore<OAuthConfigurationStore>(OAuthConfigurationStore);
        this._oauthConfigurationActionCreator = ActionCreatorManager.GetActionCreator<OAuthConfigurationActionCreator>(OAuthConfigurationActionCreator);
        this._oauthConfigurationActions = ActionsHubManager.GetActionsHub<OAuthConfigurationActions>(OAuthConfigurationActions);
    }

    public componentWillMount() {
        this._store.addChangedListener(this._onStoreChange);
        this._store.addChangedListener(this._setPageTitle);
        this._runningDocument = getRunningDocumentsTable().add(NavigationConstants.OAuthConfigurationView, this);
    }

    public componentWillUnmount() {
        this._store.removeChangedListener(this._onStoreChange);
        getRunningDocumentsTable().remove(this._runningDocument);
        super.componentWillUnmount();
    }

    public isDirty(): boolean {
        return this._store.isDirty();
    }

    public render(): JSX.Element {
        let state = this._store.getState();
        return (
            <Page className="flex-column absolute-fill oauth-container oauth-configuration-view">
                {this._getErrorMessageBar(state)}
                {/* hidden h1 for accessibility */}
                <h1 className="visibly-hidden">{Resources.OAuthConfigurationsHubTitle}</h1>
                {
                    state.dataLoaded &&
                    <React.Fragment>
                        <div className="oauth-all-tabs">
                            <div className="oauth-content scroll-hidden">
                                <div className="bread-crumbs">
                                    <HubHeader breadcrumbItems={this._getBreadCrumbItems()} />
                                </div>
                                <Icon iconName="ChevronRight" className="chevron-Right"></Icon>
                                <Tooltip overflowOnly={true} text={this._getTitle(state)}>
                                    <div className="oauth-configuration-name text-ellipses">{this._getTitle(state)}</div>
                                </Tooltip>
                            </div>
                            {
                                state.oAuthConfiguration.id &&
                                <div className="oauth-separator-vertical"></div>
                            }
                            <HeaderCommandBar className="oauth-header-commandbar" items={this._getCommandItems(state)} />
                        </div>
                        <div className="oauth-separator-horizontal"></div>
                        {this._getHubContent(state)}
                    </React.Fragment>
                }
            </Page>
        );
    }

    private _getCommandItems(state: IOAuthConfigurationState): IHeaderCommandBarItem[] {
        let items: IHeaderCommandBarItem[] = [];
        if (!state.oAuthConfiguration.id)
            return [];
        else {
            let iconColor = "iconColor"
            if (this._isCreateOrSaveButtonDisabled()) {
                iconColor = "iconColor-disable"
            }
            items.push({
                id: "save",
                text: Resources.SaveText,
                important: undefined,
                iconProps: { iconName: "Save", className: iconColor },
                onActivate: (menuItem: IMenuItem, event?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => {
                    this._onCreateOrUpdate();
                },
                className: "oauth-commandbar-item",
                subtle: true,
                disabled: this._isCreateOrSaveButtonDisabled()
            });
            items.push({
                id: "security",
                text: Resources.Security,
                important: undefined,
                iconProps: { iconName: "Shield", className: "iconColor" },
                onActivate: (menuItem: IMenuItem, event?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => {
                    this._onSecurityCommandClick();
                },
                className: "oauth-commandbar-item-shield",
                subtle: true
            });
        }
        return items;
    }

    private _getTitle(state: IOAuthConfigurationState): string {
        let title = state.oAuthConfiguration.name || Utils_String.empty;
        let dirtyChar = this._store.isDirty() || !title ? "*" : Utils_String.empty;
        return Utils_String.format("{0}{1}", title, dirtyChar);
    }

    private _getBreadCrumbItems(): IHubBreadcrumbItem[] {
        return [{
            ariaLabel: Resources.OAuthConfigurationsHubTitle,
            key: NavigationConstants.OAuthConfigurationListView,
            text: Resources.OAuthConfigurationsHubTitle,
            onClick: this._onOAuthConfigurationsHubTitleClicked
        }];
    }

    private _getHubContent(state: IOAuthConfigurationState): JSX.Element {
        // if type is unknown, show the content in UI, but user can not modify any of the content
        const isEndpointTypeKnown = this._isEndpointSourceTypeKnown(state.sourceTypes, state.oAuthConfiguration.endpointType);
        return (
            <div className={"oauth-view-hub-content"}>
                <FormItem label={Resources.OAuthConfigurationsDetailsNameColumn}>
                    <TextField
                        className={"oauth-input"}
                        value={state.oAuthConfiguration.name}
                        maxLength={512}
                        disabled={!isEndpointTypeKnown}
                        onChange={(event, value) => this._onNameChanged(value)}
                    >
                    </TextField>
                </FormItem>
                {
                    /* show dropdown for known types only*/
                    isEndpointTypeKnown ?
                        <Dropdown
                            className={"oauth-input"}
                            label={Resources.SourceType}
                            selectedKey={state.oAuthConfiguration.endpointType}
                            options={this._convertToDropdownOptions(state.sourceTypes)}
                            onChanged={this._onSourceTypeChanged}
                            disabled={!this._isAddConfigurationView()} />
                        : <FormItem label={Resources.SourceType}>
                            <TextField
                                className={"oauth-input"}
                                value={state.oAuthConfiguration.endpointType}
                                maxLength={256}
                                disabled={true}
                            >
                            </TextField>
                        </FormItem>
                }
                {this._getSourceTypeRelatedContent(state)}
                { 
                    this._isAddConfigurationView() &&
                    <PrimaryButton
                        className={"oauth-create-button"}
                        onClick={this._onCreateOrUpdate}
                        disabled={this._isCreateOrSaveButtonDisabled()} >
                        {Resources.Create}
                    </PrimaryButton>
                }
            </div>
        );
    }

    private _isEndpointSourceTypeKnown(sourceTypes: Contracts.ServiceEndpointType[], endpointType: string): boolean {
        // is endpointType matching to any of the sourceTypes given?
        return (!endpointType && (!sourceTypes || sourceTypes.length <= 0))
            || (sourceTypes || []).findIndex(sourceType => Utils_String.equals(sourceType && sourceType.name, endpointType, true)) >= 0;
    }

    private _getSourceTypeRelatedContent(state: IOAuthConfigurationState): JSX.Element {
        return (
            <div>
                <FormItem label={this._getUrlLabel(state)}>
                    <TextField
                        className={"oauth-input"}
                        value={state.oAuthConfiguration.url}
                        onChange={(event, value) => this._onUrlChanged(value)}
                        disabled={!this._isAddConfigurationView()}
                    >
                    </TextField>
                </FormItem>
                <FormItem label={Resources.ClientId}>
                    <TextField
                        className={"oauth-input"}
                        value={state.oAuthConfiguration.clientId}
                        maxLength={128}
                        onChange={(event, value) => this._onClientIdChanged(value)}
                        disabled={!this._isAddConfigurationView()}
                    >
                    </TextField>
                </FormItem>
                <FormItem
                    label={Resources.ClientSecret}
                    message={state.oAuthConfiguration.id && this._store.isSecretInvalid() && this._isAddConfigurationView() ? Resources.UpdateSecretRequiredText : Utils_String.empty}
                    error={state.oAuthConfiguration.id && this._store.isSecretInvalid() && this._isAddConfigurationView()}>
                    <TextField
                        className={"oauth-input"}
                        value={state.oAuthConfiguration.clientSecret}
                        maxLength={128}
                        onChange={(event, value) => this._onClientSecretChanged(value)}
                        inputType="password"
                        placeholder={(state.oAuthConfiguration.id && !this._store.isSecretInvalid()) || !this._isAddConfigurationView() ? "********" : Utils_String.empty}
                        disabled={!this._isAddConfigurationView()}
                    >
                    </TextField>
                </FormItem>
            </div>
        );
    }

    private _getErrorMessageBar(state: IOAuthConfigurationState): JSX.Element {
        return (<ErrorMessageBar errorMessage={state.errorMessage} />);
    }

    private _onOAuthConfigurationsHubTitleClicked = (e: React.MouseEvent<HTMLElement>): void => {
        if (e.ctrlKey) {
            return;
        } else if (!this._store.isDirty()) {
            e.preventDefault();
            Navigation_Services.getHistoryService().addHistoryPoint(undefined, { view: NavigationConstants.OAuthConfigurationListView }, undefined, false, false);
        } else {
            showConfirmNavigationDialog(Resources.ConfirmNavigation, Resources.UnsavedChanges)
                .then(() => {
                    Navigation_Services.getHistoryService().addHistoryPoint(undefined, { view: NavigationConstants.OAuthConfigurationListView }, undefined, false, false);
                });
        }
    }

    private _onNameChanged = (name: string): void => {
        this._oauthConfigurationActions.updateName.invoke(name);
    }

    private _onSourceTypeChanged = (sourceTypeOption: IDropdownOption): void => {
        this._oauthConfigurationActions.updateSourceType.invoke(sourceTypeOption.key.toString());
    }

    private _onUrlChanged = (url: string): void => {
        this._oauthConfigurationActions.updateUrl.invoke(url);
    }

    private _onClientIdChanged = (clientId: string): void => {
        this._oauthConfigurationActions.updateClientId.invoke(clientId);
    }

    private _onClientSecretChanged = (clientSecret: string): void => {
        this._oauthConfigurationActions.updateClientSecret.invoke(clientSecret);
    }

    private _onCreateOrUpdate = (): void => {
        if (this._isInputValid()) {
            this._oauthConfigurationActionCreator.createorUpdateOAuthConfiguration(this._store.getState().oAuthConfiguration);
        }
    }

    private _isCreateOrSaveButtonDisabled(): boolean {
        return !this._store.isValid() || !this._store.isDirty();
    }

    private _onSecurityCommandClick = (): void => {
        let state = this._store.getState();
        Dialogs.showSecurityDialog(LibraryItemType.OAuthConfiguration, state.oAuthConfiguration.id, state.oAuthConfiguration.name);
    }

    private _convertToDropdownOptions(sourceTypes: Contracts.ServiceEndpointType[]): IDropdownOption[] {
        return sourceTypes.map((sourceType: Contracts.ServiceEndpointType) => {
            return {
                key: sourceType.name,
                text: sourceType.displayName
            } as IDropdownOption;
        });
    }

    private _getUrlLabel(state: IOAuthConfigurationState): string {
        const sourceType = state.sourceTypes.find(sourceType => sourceType.name === state.oAuthConfiguration.endpointType);
        return sourceType ? Utils_String.localeFormat(Resources.ServerUrl, sourceType.displayName) : Resources.UrlText;
    }

    private _onStoreChange = (): void => {
        this.setState(this._store.getState());
    }

    private _isInputValid(): boolean {
        try {
            let url = Utils_Url.Uri.parse(this._store.getState().oAuthConfiguration.url, { absoluteUriRequired : true});
            return true;
        } catch (err) {
            this._oauthConfigurationActionCreator.fireUpdateErrorMessageEvent(OAuthConfigurationHubEvents.UpdateErrorMessage, Resources.OAuthConfigurationInvalidUrl);
            return false;
        }
    }

    private _isAddConfigurationView(): boolean {
        return !this._store.getState().oAuthConfiguration.id;
    }

    private _setPageTitle = (): void => { 
        if (this._store._isNewOAuthConfiguration()) {
            document.title = Utils_String.format(Resources.AddOAuthConfigurationPageTitle);
        }
        else {
            document.title = Utils_String.format(Resources.EditOAuthConfigurationPageTitle);
        }       
    }

    private _oauthConfigurationActionCreator: OAuthConfigurationActionCreator;
    private _oauthConfigurationActions: OAuthConfigurationActions;
    private _store: OAuthConfigurationStore;
    private _hubViewState: IHubViewState;
    private _runningDocument: RunningDocumentsTableEntry;
}
